import Raphael from './raphael'
import './GitlabGraph.scss'

export default class GitlabGraph

  constructor: (element1, { transformCommits, transformDays, loadData }) ->
    @element = element1
    @preparedCommits = {}
    @transformCommits = transformCommits
    @transformDays = transformDays
    @loadData = loadData
    @days = []
    @commits = []
    @mtime = 0
    @mspace = 0
    @parents = {}
    @colors = ['#000']
    @offsetX = 150
    @offsetY = 20
    @unitTime = 30
    @unitSpace = 10
    @prev_start = -1

  fetchMoreCommits: (limit, offset) ->
    data = await @loadData(limit, offset)
    @prepareData(@transformDays(data), await @transformCommits(data))

  prepareData: (days, commits) ->

    @days.push(days...)
    @commits.push(commits...)

    @collectParents()

    @graphHeight = @element.clientHeight
    @graphWidth = @element.clientWidth

    ch = Math.max(@graphHeight, @offsetY + @unitTime * @mtime + 150)
    cw = Math.max(@graphWidth, @offsetX + @unitSpace * @mspace + 300)

    @r = Raphael(@element, cw, ch)
    @top = @r.set()

    @barHeight = Math.max(@graphHeight, @unitTime * @commits.length + 320)

    @commits = @commits.reduce((acc, commit) =>
      updatedCommit = commit
      if (commit.id in @parents) then updatedCommit.isParent = true
      acc.push(updatedCommit)
      @preparedCommits[commit.id] = commit
      acc
    , [])

    @collectColors()

  collectParents: () ->
    ref = @commits
    results = []
    ref.forEach((c) =>
      @mtime = Math.max(@mtime, c.time)
      @mspace = Math.max(@mspace, c.space)
      ref1 = c.parents
      results1 = []
      ref1.forEach((p) =>
        @parents[p[0]] = true
        results1.push((@mspace = Math.max(@mspace, p[1])))
      )
      results.push(results1)
    )
    results

  collectColors: () ->
    k = 0
    results = []
    while (k < @mspace)
      @colors.push(Raphael.getColor(0.8))
      Raphael.getColor()
      Raphael.getColor()
      results.push((k += 1))
    results

  buildGraph: () ->
    mm = 0
    len = 0
    cuday = 0
    cumonth = ''
    { r } = @
    r.rect(0, 0, 40, @barHeight).attr({
      fill: '#222',
    })
    r.rect(40, 0, 30, @barHeight).attr({
      fill: '#444',
    })
    ref = @days
    for day, mm in ref
      if (cuday isnt day[0] || cumonth isnt day[1])
        r.text(55, @offsetY + @unitTime * mm, day[0]).attr({
          font: '12px Monaco, monospace',
          fill: '#BBB',
        })
        [cuday] = day
      if (cumonth isnt day[1])
        r.text(20, @offsetY + @unitTime * mm, day[1]).attr({
          font: '12px Monaco, monospace',
          fill: '#EEE',
        })
        cumonth = day[1]
    @renderPartialGraph()
    @bindEvents()

  updateSlidingWindow: (offset) ->
    rowHeight = 30
    currentFirstRow = Math.floor(offset / rowHeight)
    rowsVisible = Math.floor(window.innerHeight / rowHeight)

  renderPartialGraph: ->

    @updateSlidingWindow(@element.scrollTop)

    isGraphEdge = true
    i = 0
    start = Math.floor((@element.scrollTop - @offsetY) / @unitTime) - 10
    if (start < 0) then start = 0
    end = start + 40
    if (@commits.length < end) then end = @commits.length
    if (@prev_start is -1 || Math.abs(@prev_start - start) > 10 || isGraphEdge)
      i = start
      @prev_start = start
      while (i < end)
        commit = @commits[i]
        i += 1
        if (commit.hasDrawn isnt true)
          x = @offsetX + @unitSpace * (@mspace - commit.space)
          y = @offsetY + @unitTime * commit.time

          @drawDot(x, y, commit)
          @drawLines(x, y, commit)
          @appendLabel(x, y, commit)
          @appendAnchor(x, y, commit)
          commit.hasDrawn = true
      @top.toFront()

  bindEvents: () ->
    { element } = @
    element.onscroll = => @renderPartialGraph()

  appendLabel: (x, y, commit) ->
    return if !commit.refs

    { r } = @
    shortrefs = commit.refs
    if shortrefs.length > 17
      shortrefs = "#{shortrefs.substr(0, 15)}…"
    text = r.text(x + 4, y, shortrefs).attr({
      'text-anchor': 'start',
      font: '10px Monaco, monospace',
      fill: '#FFF',
      title: commit.refs,
    })
    textbox = text.getBBox()
    rect = r.rect(x, y - 7, textbox.width + 5, textbox.height + 5, 4).attr({
      fill: '#000',
      'fill-opacity': 0.5,
      stroke: 'none',
    })
    r.path(['M', x - 5, y, 'L', x - 15, y - 4, 'L', x - 15, y + 4, 'Z']).attr({
      fill: '#000',
      'fill-opacity': 0.5,
      stroke: 'none',
    })
    label = r.set(rect, text)
    label.transform(['t', -rect.getBBox().width - 15, 0])
    text.toFront()

  appendAnchor: (x, y, commit) ->
    { r, top } = @
    anchor = r
      .circle(x, y, 10)
      .attr({
        opacity: 0,
        cursor: 'pointer',
      }).hover(->
        @tooltip = r.commitTooltip(x + 5, y, commit)
        top.push(@tooltip.insertBefore(@))
      , ->
        @tooltip && @tooltip.remove() && delete @tooltip
      )
    top.push(anchor)

  drawDot: (x, y, commit) ->
    { r } = @
    r.circle(x, y, 3).attr({
      fill: @colors[commit.space],
      stroke: 'none',
    })
    avatarBoxX = @offsetX + @unitSpace * @mspace + 10
    avatarBoxY = y - 10

    r.rect(avatarBoxX, avatarBoxY, 20, 20).attr({
      stroke: @colors[commit.space],
      'stroke-width': 2,
    })
    r.image(commit.author.icon, avatarBoxX, avatarBoxY, 20, 20)
    r.text(@offsetX + @unitSpace * @mspace + 35, y, commit.message.split('\n')[0])
      .attr({
        'text-anchor': 'start',
        font: '14px Monaco, monospace',
        class: 'commit-message'
      })

  drawLines: (x, y, commit) ->
    i = 0
    len = 0
    arrow = ''
    offset = []
    color = []
    { r } = @
    ref = commit.parents
    results = []
    for parent in ref
      parentCommit = @preparedCommits[parent[0]]
      parentY = @offsetY + @unitTime * (parentCommit?.time || 0)
      parentX1 = @offsetX + @unitSpace * (@mspace - (parentCommit?.space || 0))
      parentX2 = @offsetX + @unitSpace * (@mspace - parent[1])

      if (parentCommit?.space != commit.space)
        color = @colors[commit.space]
      else
        color = @colors[parentCommit?.space]
      if (parent[1] is commit.space)
        offset = [0, 5]
        arrow = 'l-2,5,4,0,-2,-5,0,5'
      else if (parent[1] < commit.space)
        offset = [3, 3]
        arrow = 'l5,0,-2,4,-3,-4,4,2'
      else
        offset = [-3, 3]
        arrow = 'l-5,0,2,4,3,-4,-4,2'
      route = ['M', x + offset[0], y + offset[1]]
      if (i > 0)
        route.push(arrow)
      if (commit.space isnt parentCommit?.space || commit.space isnt parent[1])
        route.push('L', parentX2, y + 10, 'L', parentX2, parentY - 5)
      route.push('L', parentX1, parentY)
      results.push(
        r.path(route).attr({
          stroke: color,
          'stroke-width': 2,
        }),
      )
    results

